import { render, staticRenderFns } from "./formularioDespachoNovedad.vue?vue&type=template&id=0ee032b7&scoped=true"
import script from "./formularioDespachoNovedad.vue?vue&type=script&lang=js"
export * from "./formularioDespachoNovedad.vue?vue&type=script&lang=js"
import style0 from "./formularioDespachoNovedad.vue?vue&type=style&index=0&id=0ee032b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee032b7",
  null
  
)

export default component.exports